import AlgoliaNoResultsBoundary from './AlgoliaNoResultsBoundary';

export default AlgoliaNoResultsBoundary;
